export const getChannelName = ({ spaceID }: { spaceID: string }) => {
  return spaceID.replaceAll('/', '')
}
